import './StandardDateSelector.css';
import React from 'react';

const errorBorderStyle = {
  border: '3px solid red',
  borderRadius: '6px',
  verticalAlign: 'middle',
  marginTop: '4px',
  fontSize: '18px',
  color: '#666666',
};

const normalBorderStyle = {
  border: 'none',
  verticalAlign: 'middle',
  marginTop: '4px',
  fontSize: '18px',
  color: '#666666',
};

export function StandardDateSelector({
  title,
  setData,
  value = '',
  allowPast = true,
  onError = false,
  onErrorSet = () => {}, // Default to a no-op function
  errorText = '',
  errorTextSet = () => {}, // Default to a no-op function
  onChangeFunction = null,
  layout = 'vertical',
}) {
  const currentDate = new Date().toISOString().split('T')[0]; // Format date to YYYY-MM-DD
  const formRowClassName = layout === 'inline' ? 'sdsFormRow sdsFormRowInline' : 'sdsFormRow';

  const handleValueChange = (event) => {
    const selectedDate = event.target.value;
    const isPastDate = !allowPast && Date.parse(selectedDate) < Date.parse(currentDate);
  
    if (isPastDate) {
      onErrorSet(true);
      errorTextSet('Required date cannot be in the past');
      setData(''); // <- clear the value to block form submission
    } else {
      onErrorSet(false);
      errorTextSet('');
      setData(selectedDate);
    }
  
    if (onChangeFunction) {
      onChangeFunction(selectedDate);
    }
  };
  

  return (
    <div className={formRowClassName}>
      <div className="sdsTitleDiv">
        <label className="sdsTitleLabel">{title}</label>
      </div>
      <div className="sdsInputDiv">
        <input
          style={onError ? errorBorderStyle : normalBorderStyle}
          className="dateSelector"
          id="datePicker"
          type="date"
          value={value || ''}
          min={allowPast ? null : currentDate} // Disable past dates if not allowed
          onChange={handleValueChange}
        />
        <label className="sdsErrorLabel">{errorText}</label>
      </div>
    </div>
  );
}
